function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.9983 12.1327C7.90933 13.236 10.3591 12.5796 11.4624 10.6686C12.5657 8.75754 11.9093 6.3078 9.9983 5.20447C8.71658 4.46447 7.19896 4.51973 6.00185 5.20652L6.67311 6.36387C7.47392 5.91016 8.47716 5.86583 9.33163 6.35917C10.6076 7.09583 11.0444 8.72596 10.3077 10.0019C9.57103 11.2778 7.94091 11.7146 6.66497 10.978C5.81049 10.4846 5.34725 9.59365 5.33978 8.67327L4.00185 8.67062C4.00563 10.0507 4.71658 11.3927 5.9983 12.1327Z",
  fill: "#00E2FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.28509 3.95185C0.682937 6.554 0.682937 10.7778 3.28509 13.3799C5.02929 15.1241 7.49473 15.6945 9.71505 15.1053L9.37092 13.8183C7.59373 14.285 5.62326 13.8325 4.2279 12.4371C2.14429 10.3535 2.14429 6.97827 4.2279 4.89466C6.31151 2.81105 9.68676 2.81105 11.7704 4.89466C13.1657 6.29001 13.6183 8.26049 13.1469 10.0424L14.4338 10.3865C15.0278 8.16149 14.4574 5.69604 12.7132 3.95185C10.111 1.34969 5.88724 1.3497 3.28509 3.95185Z",
  fill: "#00E2FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.66669 8.66658C6.66669 7.93325 7.26669 7.33325 8.00002 7.33325C8.73335 7.33325 9.33335 7.93325 9.33335 8.66658C9.33335 9.39992 8.73335 9.99992 8.00002 9.99992C7.26669 9.99992 6.66669 9.39992 6.66669 8.66658Z",
  fill: "#00E2FF"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

var SvgIcoIntegrationProgress = function SvgIcoIntegrationProgress(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoIntegrationProgress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-integration-progress.1dd4d666.svg";
export { ForwardRef as ReactComponent };